import React from 'react';
import FollowButton from './Follow/FollowButton';
import BusinessCard from '../../core/Businesses/BusinessCard/BusinessCard';
import type { BusinessCardProps } from '../../core/Businesses/BusinessCard/BusinessCard';

type CardProps = BusinessCardProps & {
  id: number,
  business_id?: number | null,
  businessId?: number | null,
  businessSiteId?: number | null,
  followerCount: number,
  isFollowing: boolean,
  isAuthenticated: boolean,
  isRecent: boolean,
  onChange: React.MouseEventHandler,
};

const Card = ({
  id,
  name,
  business_id: businessIdFromPayloadSnake,
  businessId: businessIdFromPayloadCamel,
  businessSiteId,
  followerCount,
  isAuthenticated,
  isFollowing,
  isRecent,
  // デフォルトでは、フォローボタンを表示する
  isShowFollowButton = true,
  onChange,
  ...cardProps
}: CardProps) => {
  // トップは jbuilder で camelCase (businessId)、その他は snake_case (business_id) の可能性あり
  const businessIdFromPayload =
    businessIdFromPayloadSnake ?? businessIdFromPayloadCamel;
  // Site カード時は id が business_site_id、business_id が渡る。その場合のフォロー用 ID
  const businessId = businessIdFromPayload != null ? businessIdFromPayload : id;
  const followBusinessSiteId =
    businessIdFromPayload != null ? id : businessSiteId;

  return (
    <BusinessCard
      {...cardProps}
      isRecent={isRecent}
      name={name}
      mediaButton={
        isShowFollowButton && (
          <FollowButton
            businessId={businessId}
            businessSiteId={followBusinessSiteId}
            businessName={name}
            buttonType="rounded"
            followerCount={followerCount}
            isFollowerShown
            isAuthenticated={isAuthenticated}
            isFollowing={isFollowing}
            onChange={onChange}
          />
        )
      }
    />
  );
};

export default Card;
